import React from 'react';
import Home from './container/Home';

const App = () => (
  <Home />
);

export default App;
